module.exports = __webpack_public_path__ + "static/capsule-preview-violons-2.50f29d19.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-violons-2.png
// module id = 908
// module chunks = 168707334958949